import {getAxios} from '@deviceinsight/ng-ui-api-client';

import {ServiceStatus} from '../modules/servicestatus/types';
import {displayErrorMessage} from './apiUtils';

export const getPlatformStatus = (): Promise<Array<ServiceStatus>> => {
	return getAxios()
		.get('/rafi/v1/platformStatus')
		.then((response) => response.data)
		.catch((e) => {
			displayErrorMessage(e, 'ServiceStatus');
		});
};
